export const ID_VERIFICATION_CONSENT_VERSION = '2026-11-01-v1';
